<template>
  <div id="content" :style="pageBgStyles">
    <div class="container ">
      <div class="row info-other">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(info, key) in list.other" v-bind:key="key">
            <div class="info-other-item">
              <img :src="info.image" :title="info.title" :alt="info.title">
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="top-info">
        <h1>{{ title }}</h1>
        <p>{{ content }}</p>
      </div>
      <div class="row main-info row-centered">
        <div class="col-xs-12 col-sm-3 col-centered" v-for="(info, key) in list.main" v-bind:key="key">
          <div class="main-info-item">
            <icon class="icon" :name="getIcon(key)" scale="2"></icon>
            <p>{{ info}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Icon from 'vue-awesome/components/Icon'
  import 'vue-awesome/icons/check-square-o'
  import 'vue-awesome/icons/building'
  import 'vue-awesome/icons/wrench'
  import pageBgStyles from '../common/js/page-bg-styles'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import getMeta from '../common/js/get-meta'
  export default {
    mixins: [pageBgStyles, getMeta],
    components: {
      Icon,
      swiper,
      swiperSlide
    },
    data () {
      return {
        // pageBgStyles: '',
        title: 'Ремонт дизельной топливной аппаратуры',
        image: '/static/index.jpg',
        content: 'Основное направление нашего сервиса - ремонт топливных дизельных систем. ',
        list: {
          main: [
            'На рынке автосервисных услуг уже более 15 лет',
            'Обслуживаем более 700 предприятий региона',
            'Ремонт ТНВД, форсунок, насос-форсунок, Common Rail',
            'Ремонт дизельных двигателей'
          ],
          other: [
            {
              title: 'Авторизованный сервисный центр Delphi',
              image: '/static/manufactures/delphi.png'
            },
            {
              title: 'Официальный представитель Cummins',
              image: '/static/manufactures/cummins.png'
            },
            {
              title: 'Установка фильтров сепараторов Stanadyne',
              image: '/static/manufactures/stanadyne.png'
            },
            {
              title: 'Установка фильтров Fleetguard',
              image: '/static/manufactures/fleetguard.png'
            },
            {
              title: 'Ремонт топливной аппаратуры Bosch',
              image: '/static/manufactures/bosch.png'
            },
            {
              title: 'Ремонт топливной аппаратуры Delphi',
              image: '/static/manufactures/delphi.png'
            },
            {
              title: 'Ремонт топливной аппаратуры Detroit Diesel',
              image: '/static/manufactures/detroit.png'
            },
            {
              title: 'Ремонт топливной аппаратуры Siemens',
              image: '/static/manufactures/siemens.png'
            }
          ]
        },
        swiperOption: {
          slidesPerView: 5,
          autoplay: 3000,
          spaceBetween: 0,
          loop: true,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 0
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 0
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 0
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 0
            }
          }
        }
      }
    },
    methods: {
      getIcon: function (key) {
        switch (key) {
          case 0:
            return 'check-square-o'
          case 1:
            return 'building'
          default:
            return 'wrench'
        }
      }
    }
  }

</script>
<style lang="stylus" scoped>
@import '../common/css/vars'

img
  height 100%
  width auto
  filter brightness(90%)
  transition 0.2s all ease-out

  &:hover
    filter none

.main-info
  margin-top 30px
  margin-left 0
  margin-right 0

.main-info-item
  max-width 190px
  min-height 215px
  padding 30px 10px
  border 2px solid $white
  border-radius 5px
  margin 0 auto
  background-color rgba(79, 79, 79, 0.86)
  box-shadow 4px 4px 2px rgba(150, 150, 150, 1)

  .icon
    box-shadow 4px 4px 2px rgba(150, 150, 150, 1)

  p
    font-size 16px
    font-weight 600

.info-other
  padding 10px 0
  background $white
  box-shadow inset 60px 0 80px #000, inset -60px 0 50px #000
  outline 1px solid #000
  border 1px solid #000

.info-other-item
  height 25px
  margin 0 auto
</style>



// WEBPACK FOOTER //
// Index.vue?714bca0d